import { render, staticRenderFns } from "./MedicalAlertAdd.vue?vue&type=template&id=24f09a32&scoped=true&"
import script from "./MedicalAlertAdd.vue?vue&type=script&lang=js&"
export * from "./MedicalAlertAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f09a32",
  null
  
)

export default component.exports